<template>
  <span class="svg-ico-neutral">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.93573 9.84255C8.48387 9.84255 8.11755 10.2089 8.11755 10.6607C8.11755 11.1126 8.48387 11.4789 8.93573 11.4789H8.9478C9.39967 11.4789 9.76598 11.1126 9.76598 10.6607C9.76598 10.2089 9.39967 9.84255 8.9478 9.84255H8.93573Z" :fill="color"/>
      <path d="M14.4811 10.6607C14.4811 10.2089 14.8474 9.84255 15.2993 9.84255H15.3114C15.7633 9.84255 16.1296 10.2089 16.1296 10.6607C16.1296 11.1126 15.7633 11.4789 15.3114 11.4789H15.2993C14.8474 11.4789 14.4811 11.1126 14.4811 10.6607Z" :fill="color"/>
      <path d="M8.93573 15.1376C8.48387 15.1376 8.11755 15.5039 8.11755 15.9558C8.11755 16.4077 8.48387 16.774 8.93573 16.774H15.2994C15.7512 16.774 16.1176 16.4077 16.1176 15.9558C16.1176 15.5039 15.7512 15.1376 15.2994 15.1376H8.93573Z" :fill="color"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M22.4812 12.7788C22.4812 4.80987 13.8434 -0.166335 6.93618 3.81565C3.72975 5.66407 1.75391 9.08068 1.75391 12.7788C1.75391 20.7477 10.3916 25.7239 17.2989 21.7419C20.5053 19.8934 22.4812 16.4768 22.4812 12.7788ZM7.75345 5.23331C13.5735 1.87811 20.8448 6.07329 20.8448 12.7788C20.8448 15.891 19.182 18.7675 16.4816 20.3242C10.6616 23.6794 3.39027 19.4842 3.39027 12.7788C3.39027 9.66647 5.05314 6.78997 7.75345 5.23331Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this && this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default () { return this && this.$store.state.color['coolGrey-50'] } },
    isFixedColor: { type: Boolean },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
